/**
 * Baja un `Blob` como archivo (link temporal + click). Es lo único que toca el DOM de la descarga
 * del CSV (el pedido con JWT vive en `metaAdsService.downloadMetaResultsCsv`).
 *
 * @param {Blob} blob
 * @param {string} filename
 */
export function saveBlobAs(blob, filename) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.rel = 'noopener';
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  link.remove();
  // El click ya disparó la descarga; se libera la URL en el próximo ciclo.
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
